module.exports = __webpack_public_path__ + "static/media/windsock.b4fee380.svg";